import React from 'react';
import './ComingSoon.css';

/**
 * Componente reutilizable para páginas en construcción.
 * Props:
 *   - title: string  — título de la página
 *   - subtitle: string (opcional) — subtítulo descriptivo
 *   - icon: string (opcional) — emoji o carácter de ícono
 */
const ComingSoon = ({ title, subtitle = 'Contenido próximamente', icon = '🏗️' }) => {
  return (
    <div className="coming-soon">
      <div className="coming-soon__card">
        <span className="coming-soon__icon">{icon}</span>
        <h1 className="coming-soon__title">{title}</h1>
        <p className="coming-soon__subtitle">{subtitle}</p>
        <div className="coming-soon__bar">
          <div className="coming-soon__bar-fill" />
        </div>
        <p className="coming-soon__note">Estamos trabajando en esta sección</p>
      </div>
    </div>
  );
};

export default ComingSoon;
